import type { Carousel } from '@ps/web-martech-cms-types';
import React from 'react';

import CMSHeading from '../CMSHeading/CMSHeading';

import styles from './CMSCarousel.scss';
import CasinoGamesCarousel from './CasinoGamesCarousel';
import DefaultCarousel from './DefaultCarousel/DefaultCarousel';
import ProspectHomepageCarousel from './ProspectHomepageCarousel/ProspectHomepageCarousel';

const CMSCarousel: React.FC<Carousel> = ({
  auto_rotate: autoRotate,
  prospect_homepage_slides: prospectHomepageSlides,
  rotation_speed: rotationSpeed,
  slides,
  variant,
  heading
}) => {
  const slideSpeed = Number(rotationSpeed) * 1000;
  const hasTitleInHeading = !!heading?.title || !!heading?.logged_in_title;

  return (
    <>
      {hasTitleInHeading && (
        <div className={styles.headingContainer}>
          <CMSHeading {...heading} />
        </div>
      )}
      {variant === 'Casino Games' && (
        <CasinoGamesCarousel
          autoRotate={autoRotate}
          slideSpeed={slideSpeed}
          withHeading={hasTitleInHeading}
        />
      )}
      {variant === 'Prospect Homepage' && (
        <ProspectHomepageCarousel
          autoRotate={autoRotate}
          slides={prospectHomepageSlides}
          slideSpeed={slideSpeed}
          withHeading={hasTitleInHeading}
        />
      )}
      {variant === 'Default' && (
        <DefaultCarousel
          autoRotate={autoRotate}
          slides={slides}
          slideSpeed={slideSpeed}
          withHeading={hasTitleInHeading}
        />
      )}
    </>
  );
};

export default CMSCarousel;
